module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alreadyImported":"Already imported"},"fr":{"alreadyImported":"Déjà importé"},"de":{"alreadyImported":"Bereits importiert"}}')
  delete Component.options._Ctor
}
